


















































































































































import Vue from 'vue'
import InfoBanner from '@/components/InfoBanner.vue'
import subscriptionMixin from '@/mixins/subscription-mixin.js'
import SubscriptionOption from '@/types/SubscriptionOption.interface'
import { trialDays } from '@/utility/helpers'
export default Vue.extend({
    mixins: [subscriptionMixin],
    components: { InfoBanner },
    data() {
        return {
            annualPlansShow: true,
            plan: null,
            features: [
                ['📤 Basic team inbox', '📣 Broadcast to 50 contacts'],
                [
                    '📤 Advanced team inbox',
                    '📣 Broadcast to 1000 contacts',
                    '⏰ Text message scheduling'
                ],
                [
                    '📤 Advanced team inbox',
                    '📣 Broadcast to 2000 contacts',
                    '⏰ Scheduling and automation',
                    '🙋 Priority support'
                ]
            ],
            meteredRates: [0.05, 0.04, 0.03]
        }
    },
    computed: {
        displayBanner(): boolean {
            return this.$store.getters.displayPricingBanner
        },
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        isUpgrade(): Function {
            return this.$store.getters.isUpgrade
        },
        monthOptions(): SubscriptionOption[] {
            let options = this.$store.getters.monthOptions

            //  If no options, return null
            if (!options) return null

            //  Return our array once we filter for active, and sort by index
            return options
                .filter(
                    (x) =>
                        x.metadata.is_active === 'true' &&
                        x.metadata.default_start_plan !== 'true'
                )
                .sort((a, b) => {
                    return a.metadata.index - b.metadata.index
                })
        },
        options(): SubscriptionOption[] {
            //  If annual toggle is on, show annual plans, otherwise show monthly plans
            let options = this.annualPlansShow ? this.yearOptions : this.monthOptions

            return options
        },
        yearOptions(): SubscriptionOption[] {
            //  Get all year options to be filtered / sorted
            let options = this.$store.getters.yearOptions

            //  If no options, return null
            if (!options) return null

            //  Return our array once we filter for active, and sort by index
            return options
                .filter(
                    (x) =>
                        x.metadata.is_active === 'true' &&
                        x.metadata.default_start_plan !== 'true'
                )
                .sort((a, b) => {
                    return a.metadata.index - b.metadata.index
                })
        }
    },
    methods: {
        buttonText(plan: SubscriptionOption): string {
            //  If plan is our trialing plan, say "Convert to Paid"
            if (this.trialing(plan)) return 'Start Subscription'

            //  If plan is already purchased, just say Purchased
            if (this.purchased(plan, true)) return 'Purchased'

            //  If the plan tier is the same but the plan they are looking at is yearly
            if (this.purchased(plan) && plan.interval == 'year') return 'Switch to annual'

            //  If the plan tier is the same but the plan they are looking at is monthly
            if (this.purchased(plan) && plan.interval == 'month') {
                return 'Switch to monthly'
            }

            //  If plan is an upgrade, say upgrade
            if (this.isUpgrade(plan)) return 'Upgrade'

            //  Otherwise downgrade
            return 'Downgrade'
        },
        closeBanner(): void {
            this.$store.commit('closePricingBanner')
        },
        downgradeClicked(plan: SubscriptionOption): void {
            const edgeCase =
                this.upgradeEdgeCase(plan) ||
                (this.purchased(plan) && plan.interval == 'month')

            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                icon: 'bi-credit-card-2-front-fill',
                title: edgeCase
                    ? 'Subscription Interval Changes'
                    : 'Subscription Downgrades',
                color: 'primary',
                text: 'Please email <a href="mailto:support@messagedesk.com">support@messagedesk.com</a> if you want to downgrade your subscription or change billing intervals'
            })
        },
        goToPlans() {
            window.open(
                'https://www.messagedesk.com/pricing',
                this.isApp ? '_system' : '_blank'
            )
        },
        viewPlan(plan: SubscriptionOption): void {
            const index = plan.metadata.index

            return this.$router.push(`/billing/manage?index=${index}`)
        },
        purchased(plan: SubscriptionOption, useInterval: boolean = false): boolean {
            //  If no current plan, nothig is purchased
            if (!this.currentPlan) return false

            //  If subscription is canceled, nothing is purchased
            if (this.subscription.status === 'canceled') return false

            //  If subscription is trialing, nothing is purchased
            if (this.subscription.status === 'trialing') return false

            //  If custom plan with no metadata, return false
            if (!this.currentPlan.metadata) return false

            //  If current product tier is equal to plan's product tier, we are on that plan
            let purchased =
                this.currentPlan.metadata.product_tier === plan.metadata.product_tier

            //  If we want to be more granular, check interval of plan if purchased
            if (purchased && useInterval) {
                return plan.interval === this.currentPlan.interval
            }

            //  Otherwise just return if the user is on that product tier
            return purchased
        },
        trialing(plan: SubscriptionOption): boolean {
            //  Grab subscription status
            const status = this.subscription.status

            //  If we are NOT trialing then return false
            if (status !== 'trialing') return false

            //  Else, check if our plan ids match
            return plan.id === this.currentPlan.id
        },
        trialDays(): string {
            return trialDays()
        },
        //  If a user is on an annual plan and viewing another plan that is a higher tier but on a monthly interval => Do not allow
        upgradeEdgeCase(plan: SubscriptionOption): boolean {
            if (this.subscription.status != 'active') return false

            if (
                this.currentPlan.interval == 'year' &&
                plan.interval == 'month' &&
                this.currentPlan.metadata.index < plan.metadata.index
            ) {
                return true
            }

            return false
        }
    }
})
